import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Container,
  Dropdown,
  Menu,
} from 'semantic-ui-react';
import { replace } from 'react-router-redux';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { fetchM } from '../../../actions/fetchM';
import { flashSuccessMessage, flashErrorMessage } from '../../../actions/flash';
import MediaList from '../../../components/MediaList';
import NavBar from '../../../components/NavBar';
import AddMedia from '../../modals/AddMedia';
import ViewLarge from '../../modals/ViewLarge';
import RemoveMedia from '../../modals/RemoveMedia';
import { editRoutes } from '../navigations';
import config from '../../../../config';
import { namespaces, TRANSLATION_FILES } from '../../../constants/translation';

class Videos extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    mediaToken: PropTypes.string,
    id: PropTypes.string,
    t: PropTypes.func,
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
      pathname: PropTypes.string,
    }),
    data: PropTypes.shape({
      name: PropTypes.string,
    }),
    appConfig: PropTypes.shape({
      data: PropTypes.shape({
        lawyerIsEnabled: PropTypes.bool,
      }),
    }),
    auth: PropTypes.shape({
      company: PropTypes.object,
    }),
  }
  static mapStateToProps = state => ({
    auth: state.auth,
    appConfig: state.appConfig,
  })
  static getPropsToState = (props) => {
    const loading = props.loading;
    const menuIsTab = window.innerWidth <= 590;
    return {
      loading,
      menuIsTab,
    };
  }
  constructor(props) {
    super(props);
    const state = Videos.getPropsToState(props);
    this.state = {
      ...state,
      showConfirm: false,
      showLarge: false,
      selectedMedia: null,
      showAddMedia: false,
    };
    this.mediaList = null;
  }
  componentDidMount() {
    window.addEventListener('resize', this.handleResize, false);
  }
  componentWillReceiveProps(nextProps) {
    const state = Videos.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, false);
  }
  handleResize = () => {
    const menuIsTab = window.innerWidth <= 590;
    if (menuIsTab !== this.state.menuIsTab) {
      this.setState({ menuIsTab });
    }
  }
  handleRefetch() {
    this.setState({
      selectedMedia: null,
    });
    if (this.mediaList) {
      this.mediaList.getWrappedInstance().handleRefetch();
    }
  }
  addMedia = () => {
    const { t } = this.props;
    const { store } = this.context;
    store.dispatch(fetchM(`/projects/${this.props.id}/medias/${this.state.selectedMedia.id}/`, {
      credentials: 'include',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Csrf-Token': this.props.mediaToken,
      },
    }))
      .then(() => {
        this.mediaModal.handleRefetch();
        store.dispatch(flashSuccessMessage({ header: t('Add Video Success', { ns: TRANSLATION_FILES.translation }), message: t('Video successfully added to project', { ns: TRANSLATION_FILES.translation }) }));
      })
      .catch((err) => {
        store.dispatch(flashErrorMessage(err));
      });
  }
  deleteMedia() {
    const { t } = this.props;
    const { store } = this.context;
    store.dispatch(fetchM(`/projects/${this.props.id}/medias/${this.state.selectedMedia.id}/`, {
      credentials: 'include',
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'X-Csrf-Token': this.props.mediaToken,
      },
    }))
      .then(() => {
        this.handleRefetch();
        store.dispatch(flashSuccessMessage({ header: t('Remove Success', { ns: TRANSLATION_FILES.translation }), message: t('Video successfully removed', { ns: TRANSLATION_FILES.translation }) }));
      })
      .catch((err) => {
        store.dispatch(flashErrorMessage(err));
      });
  }
  handleCancelRemove = (e) => {
    e.preventDefault();
    this.setState({
      showConfirm: false,
      selectedMedia: null,
    });
  }
  handleRemove = (e, selectedMedia) => {
    e.preventDefault();
    this.setState({
      selectedMedia,
    }, () => {
      this.setState({
        showConfirm: true,
      });
    });
  }
  handleConfirmRemove = (e) => {
    e.preventDefault();
    this.setState({
      showConfirm: false,
    }, () => {
      this.deleteMedia();
    });
  }
  handleCloseLarge = (e) => {
    e.preventDefault();
    this.setState({
      showLarge: false,
      selectedMedia: null,
    });
  }
  handleViewLarge = (e, selectedMedia) => {
    e.preventDefault();
    this.setState({
      selectedMedia,
      showLarge: true,
    });
  }
  handleShowAddMedia = (e) => {
    e.preventDefault();
    this.setState({
      showAddMedia: true,
    });
  }
  handleCloseAddMedia = (e) => {
    if (e) { e.preventDefault(); }
    this.handleRefetch();
    this.setState({
      showAddMedia: false,
    });
  }
  handleAddMedia = (e, selectedMedia) => {
    e.preventDefault();
    this.setState({
      selectedMedia,
    }, () => {
      this.addMedia();
    });
  }
  handleCreate = data => ({
    url: `/projects/${this.props.id}/medias/`,
    options: {
      credentials: 'include',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Csrf-Token': this.props.mediaToken,
      },
      body: JSON.stringify(data),
    },
  })
  handleCheck = (data) => {
    if (data.projects && data.projects.length > 0) {
      return data.projects.some(p => p.projectID === this.props.id);
    }
    return false;
  }
  handleMenu = (e, { value }) => {
    const { store } = this.context;
    if (value.includes(config.get('developerURL'))) {
      e.preventDefault();
      window.location.href = value;
    } else {
      store.dispatch(replace(value));
    }
  }
  render() {
    const { auth, id, location, t } = this.props;
    const { pathname } = location;
    const companyServiceID = auth && auth.company && auth.company.service_company_id ? auth.company.service_company_id : '';
    const isMalaysia = auth && auth.company && auth.company.countryCode.toUpperCase() === 'MY';
    const links = editRoutes(id, this.props.appConfig.data && this.props.appConfig.data.lawyerIsEnabled, isMalaysia, companyServiceID).map(l => ({
      ...l,
      text: t(l.text, { ns: l.text === 'Edit' ? TRANSLATION_FILES.translation : TRANSLATION_FILES.screens }),
    }));
    return (
      <Container>
        <NavBar
          links={
            this.state.menuIsTab ?
              <Dropdown
                item
                selectOnBlur={false}
                options={links}
                onChange={this.handleMenu}
                value={pathname}
              />
            : links.map((link, key) => (
              <Menu.Item
                key={key}
                name={link.text}
                active={pathname === link.value}
                onClick={e => this.handleMenu(e, link)}
              />
            ))
          }
          rightNav={
            <Menu.Item fitted>
              <Button
                onClick={this.handleShowAddMedia}
                disabled={this.state.loading}
                primary
                icon="add"
                content={t('Add', { ns: TRANSLATION_FILES.translation })}
              />
            </Menu.Item>
          }
        />
        <AddMedia
          type="project"
          ref={(ref) => { this.mediaModal = ref; }}
          open={this.state.showAddMedia}
          onClose={this.handleCloseAddMedia}
          onConfirm={this.handleAddMedia}
          onCreate={this.handleCreate}
          onCheck={this.handleCheck}
        />
        <ViewLarge
          open={this.state.showLarge}
          onClose={this.handleCloseLarge}
          picture={this.state.selectedMedia}
          type="video"
        />
        <RemoveMedia
          open={this.state.showConfirm}
          onClose={this.handleCancelRemove}
          onConfirm={this.handleConfirmRemove}
          media={this.state.selectedMedia}
          data={this.props.data}
        />
        <MediaList
          ref={(ref) => { this.mediaList = ref; }}
          toggleable
          projectID={this.props.id}
          onViewLarge={this.handleViewLarge}
          onRemove={this.handleRemove}
          buttonNode={({ isMobile, view, loading, item }) => (
            view === 'list' ? (
              <Button
                size="tiny"
                compact
                negative
                icon="remove"
                content={isMobile ? null : t('Remove', { ns: TRANSLATION_FILES.translation })}
                disabled={loading}
                onClick={e => this.handleRemove(e, item)}
              />
            ) : null
          )}
        />
      </Container>
    );
  }
}

export default withTranslation(namespaces)(connect(Videos.mapStateToProps)(Videos));



// WEBPACK FOOTER //
// ./src/containers/Project/Videos/List.jsx